
























































/* General */
import Vue from 'vue'
import MainContainer from '@/layouts/main-container.vue'

/* Mixins */

/* Components */
import TaskDetailMetaOptions from './task-detail-meta-options.vue'

/* Helpers */
import BreadcrumbAssistant from '@/helpers/breadcrumb-assistant'
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */
import { EEntities } from '@/types'
import {
  IPersonWithEmail,
  IPriorityLevelForSelection,
  IStatusForSelection,
} from '@/api/types/response.types'
import { IAttachment } from '@/types/data-objects/attachments'
import { IJobInfo } from '@/types/data-objects/items'

/* API */

export default Vue.extend({
  name: 'TaskDetailTopbar',

  components: {
    MainContainer,
    TaskDetailMetaOptions,
  },

  props: {
    refNumber: {
      type: Number,
      required: true,
    },

    taskTitle: {
      type: String,
      required: true,
    },

    projectId: {
      type: Number,
      required: true,
    },

    projectName: {
      type: String,
      required: true,
    },

    assigneeId: {
      type: Number,
      default: null,
    },

    priorityId: {
      type: Number,
      required: true,
    },

    statusId: {
      type: Number,
      required: true,
    },

    dueDate: {
      type: [Date, String],
      default: null,
    },

    statusOptions: {
      type: Array as () => IStatusForSelection[],
      required: true,
    },

    priorityOptions: {
      type: Array as () => IPriorityLevelForSelection[],
      required: true,
    },

    assigneesOptions: {
      type: Array as () => IPersonWithEmail[],
      required: true,
    },

    globalAttachments: {
      type: Array as () => IAttachment[],
      required: true,
    },

    jobInfo: {
      type: Object as () => IJobInfo,
      default: null,
    },

    showHarvestOption: {
      type: Boolean,
      required: true,
    },

    disablePickerOptions: {
      type: Boolean,
      required: true,
    },

    isPinned: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      EEntities,
      RouteAssistant,
      BreadcrumbAssistant,
      revealExpandedInfo: false,
    }
  },

  computed: {
    hasGlobalAttachments(): boolean {
      return this.globalAttachments.length > 0
    },
    internalStatusID: {
      get(): any {
        return this.statusId
      },
      set(newValue: any) {
        if (this.statusId !== newValue) {
          this.$emit('update-status', newValue)
        }
      },
    },

    internalPriorityID: {
      get(): any {
        return this.priorityId
      },
      set(newValue: any) {
        if (this.priorityId !== newValue) {
          this.$emit('update-priority', newValue)
        }
      },
    },

    internalDueDate: {
      get(): any {
        return this.dueDate
      },
      set(newValue: any) {
        if (this.dueDate !== newValue) {
          this.$emit('update-dueDate', newValue)
        }
      },
    },

    internalAssigneeID: {
      get(): any {
        return this.assigneeId
      },
      set(newValue: any) {
        if (this.assigneeId !== newValue) {
          this.$emit('update-assignee', newValue)
        }
      },
    },
  },

  mounted() {
    document.addEventListener('scroll', this.checkScrollPosition)
  },

  beforeDestroy() {
    document.removeEventListener('scroll', this.checkScrollPosition)
  },

  methods: {
    checkScrollPosition() {
      // Low-fi estimated height where the title/meta options is scrolled up.
      // Didn't want to get too sophisticated here.
      this.revealExpandedInfo = window.scrollY > 250
    },
  },
})
